// extracted by mini-css-extract-plugin
module.exports = {"root":"_2w_mT2jUzRrq-QZDfcTqwg","checkbox":"_1Jh6WkJGrFEY0smDnO5HUe","checkboxOuter":"CW_zI28dmYKO_m9_tPzw7","checked":"_19uLsuOH2L6AsFyrMhRRGv"};